import { useEffect, useState } from "react";
import { useLocation } from "react-router";

import { Bars3Icon } from "@heroicons/react/24/outline";

import NotificationBell from "~/components/NotificationBell";
import Sidebar from "~/components/Sidebar";
import ProfileDropdown from "~/molecules/ProfileDropdown";

const HeaderSidebarProfile = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const pathname = useLocation().pathname;

  useEffect(() => {
    setSidebarOpen(false);
  }, [pathname]);

  return (
    <>
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

      <div className="z-40 shrink-0">
        <div className="flex h-16 items-center gap-x-4 border-b border-gray-200 bg-white px-4 shadow-xs sm:gap-x-6 sm:px-6 lg:px-8 lg:shadow-none">
          <button
            type="button"
            className="-m-2.5 p-2.5 text-gray-700 lg:hidden"
            onClick={() => setSidebarOpen(true)}
          >
            <span className="sr-only">Open sidebar</span>
            <Bars3Icon className="h-6 w-6" aria-hidden="true" />
          </button>

          {/* Separator */}
          <div className="h-6 w-px bg-gray-200 lg:hidden" aria-hidden="true" />

          <div className="flex flex-1 gap-x-4 self-stretch lg:gap-x-6">
            <div className="ml-auto flex items-center gap-x-4 lg:gap-x-6">
              <NotificationBell />

              {/* Separator */}
              <div className="block h-6 w-px bg-gray-200" aria-hidden="true" />

              <ProfileDropdown />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HeaderSidebarProfile;
